<template>
  <div id="notice">
    <div class="mainFixed" style="position:relative;top:0;width:calc(100% - 60px);">
      <!-- 公告发布 -->
      <div class="allSearch d_flex">
        <div class="noticeTop">
          <div class="announcement"></div>
          <div class="cement">{{$t('common.Announcement')}}</div>
        </div>
      </div>
      <!-- 产品线 -->
      <div class="select">
        <dl style="display: flex;">
          <dd>
            <span class="product_line">{{$t('common.TA')}}:</span>
            <div class="dis_line v_m">
              <allSelect :multiple="true"
                         :chooseData="hospitalList"
                         :needReturn="'id'"
                         :matchValue="'title'"
                         :showValue="'{{title}}'"
                         v-model="postData.brandCode"
                         :width="'200px'">
              </allSelect>
            </div>
          </dd>
          <dd>
            <span class="product_line">Region:</span>
            <div class="dis_line v_m">
              <allSelect :multiple="true"
                         :chooseData="RegionList"
                         :needReturn="'TerritoryCode'"
                         :matchValue="'TerritoryName'"
                         :showValue="'{{TerritoryName}}'"
                         v-model="postData.cityCode"
                         :width="'200px'">
              </allSelect>
            </div>
          </dd>
        </dl>
        <div class="textarea">
          <textarea name=""
                    id=""
                    maxlength="150"
                    v-model="text"
                    :placeholder="$t('common.AnnouncementPlaceHolder')"></textarea>
          <div class="submit"
               @click="getSubmit"><i class="icon iconfont icon-166991"></i>{{$t('common.Submit')}}</div>
        </div>
      </div>
      <div class="unload"
           @click="getunload"><i class="icon iconfont icon-execute-stop
"></i>{{$t('common.BatchStop')}}</div>

      <table class="allTable"
             cellspacing="0">
        <thead>
          <tr>
            <td class="w_3">{{$t('common.Content')}}</td>
            <td class="w_2">{{$t('common.TA')}}</td>
            <td class="w_2">Region</td>
            <td class="w_2">{{$t('common.Status')}}</td>
            <td class="w_2">{{$t('common.Action')}}</td>
            <td class="w_2">{{$t('common.CreatedBy')}}</td>
            <td class="w_2">{{$t('common.LastUpdatedAt')}}</td>
          </tr>
        </thead>
        <tbody>
          <template v-if="noticeList&& noticeList.length !==0">
            <tr v-for="(item,index) in noticeList"
                :key="index">
              <td class="w_3">{{item.Notice}}</td>
              <td class="w_2">{{item.TAName}}</td>
              <td class="w_2">{{item.RegionName}}</td>
              <td class="w_2">{{item.Status ? $t('common.Active') : $t('common.Inactive')}}</td>
              <td class="w_2"><i v-if="item.Status"
                   class="icon iconfont icon-ziyuan"
                   style="color: #c50f3c;"
                   @click="getoperation(item)"></i></td>
              <td class="w_2">{{item.ModifyBy}}</td>
              <td class="w_2">{{item.ModifyTime}}</td>
            </tr>
          </template>
          <tr v-else>
            <th colspan="8">{{$t('common.noData')}}</th>
          </tr>
        </tbody>
      </table>
      <page :totalPage='page'
            :page='offset'
            @on-getList="pageChange"
            v-if="noticeList && noticeList.length !==0"></page>
    </div>
    <dialogArea :show='show'
                @cancel='cancel'
                @confirm="confirm"
                :title="$t('common.Submitted')">
      <div slot="content">
        <div class="affirm">{{$t('common.SubmitMsg')}}</div>
      </div>
    </dialogArea>
    <!-- 确认停止 -->
    <dialogArea :show='falg'
                @cancel='stop'
                @confirm="cease"
                :title="$t('common.Stoped')">
      <div slot="content">
        <div class="affirm">{{$t('common.StopMsg')}}</div>
      </div>
    </dialogArea>
    <!-- 确认批量停止 -->
    <dialogArea :show='batch'
                @cancel='cancelled'
                @confirm="batchStop"
                :title="$t('common.IsBatchStop')">
      <div slot="content">
        <div class="affirm">{{$t('common.BatchStopMsg')}}</div>
      </div>
    </dialogArea>
    <!-- 批量停止弹框 -->
    <dialogArea :show='unload'
                @cancel='uninstall'
                @confirm="discharge"
                :title="$t('common.BatchStop')"
                width='80%'>
      <div slot="content">
        <table class="allTable"
               cellspacing="0">
          <thead>
            <tr>
              <td class="w_3"><input type="checkbox"
                       ref="checkedAll"
                       @click="selectAll" /> </td>
              <td class="w_3">{{$t('common.Content')}}</td>
              <td class="w_2">{{$t('common.TA')}}</td>
              <td class="w_2">Region</td>
              <td class="w_2">{{$t('common.Status')}}</td>
              <td class="w_2">{{$t('common.Action')}}</td>
              <td class="w_2">{{$t('common.CreatedBy')}}</td>
              <td class="w_2">{{$t('common.LastUpdatedAt')}}</td>
            </tr>
          </thead>
          <tbody>
            <template>
              <tr v-for="(item) in pop.items"
                  :key="item.Id">
                <td class="w_3"><input ref="checked"
                         :name="item.Id"
                         @change="checkedChange"
                         type="checkbox" /> </td>
                <td class="w_3">{{item.Notice}}</td>
                <td class="w_2">{{item.TAName}}</td>
                <td class="w_2">{{item.RegionName}}</td>
                <td class="w_2">{{item.Status ? $t('common.Active') : $t('common.Inactive')}}</td>
                <td class="w_2"><i v-if="item.Status"
                     class="icon iconfont icon-ziyuan"
                     style="color: #c50f3c;"></i></td>
                <td class="w_2">{{item.ModifyBy}}</td>
                <td class="w_2">{{item.ModifyTime}}</td>
              </tr>
            </template>
          </tbody>
        </table>
        <page :totalPage='pop.pages'
              :page='pop.offset'
              @on-getList="pageChanges"></page>
      </div>
    </dialogArea>
  </div>
</template>

<script>
// import Axios from 'axios'
export default {
  data () {
    return {
      batch: false,
      postData: {
        brandCode: '',
        cityCode: '',
        hospitalCodes: ''
      },
      // 分页
      offset: 0,
      page: 0,
      hospitalList: [
        {
          title: this.$t('common.All'),
          id: ''
        },
        {
          title: 'HIV',
          id: 'HIV'
        },
        {
          title: 'HBV',
          id: 'HBV'
        },
        {
          title: 'HCV',
          id: 'HCV'
        }
      ],
      RegionList: [
        {
          TerritoryName: this.$t('common.All'),
          TerritoryCode: ''
        }
      ],
      show: false,
      falg: false,
      text: '',
      noticeList: [],
      unload: false,
      item: {},
      check: [],
      pop: {}
    }
  },
  beforeCreate () {
    this.$parent.topName = this.$t('common.AnnouncemenetManagement')
  },
  created () {
    this.getnoticeList()
    this.$axiox.get('/api/v1/admin/notice/regions').then(res => {
      // this.RegionList = res.data
      this.RegionList.push(...res.data)
    })
  },
  methods: {
    // 批量卸载
    getunload () {
      this.unload = true
      this.getnoticeList(1, 6, true)
    },
    uninstall (val) {
      this.unload = val
    },
    discharge () {
      const selectList = Array.from(this.$refs['checked'])
      let uninstall = selectList.every(item => {
        return item.checked === false
      })
      if (uninstall) {
        return this.$commonJs.alertTips({
          type: 'error',
          content: this.$t('common.BatchStopNoSeltMsg'),
          stayTime: 5
        })
      }
      this.check = Array.from(this.$refs['checked'])
      this.unload = false
      this.batch = true
    },
    cancelled (val) {
      this.batch = val
    },
    batchStop (val) {
      this.$axiox.delete('/api/v1/admin/notice', { data: this.getChecked() }).then(res => {
        this.getnoticeList()
        this.batch = val
        this.$commonJs.alertTips({
          type: 'success',
          content: this.$t('common.BatchStopSuccessfully'),
          stayTime: 5
        })
      })
    },
    getnoticeList (pageIndex = 1, pageSize = 6, isActive) {
      let active = `/api/v1/admin/notice/list?pageIndex=${pageIndex}&pageSize=${pageSize}`
      if (isActive) {
        active += `&isActive=${isActive}`
      }
      this.$axiox.get(active).then(res => {
        if (isActive) {
          this.pop = res.data
        } else {
          this.noticeList = res.data.items
          this.offset = res.data.offset
          this.page = res.data.pages
        }
        if (this.unload) {
          this.$refs.checkedAll.checked = false
        }
      })
    },
    pageChange (val) {
      this.getnoticeList(val, 6)
    },
    pageChanges (val) {
      this.getnoticeList(val, 6, true)
    },
    getSubmit () {
      if (this.text === '' || this.text.trim() === '') {
        this.$commonJs.alertTips({
          type: 'error',
          content: this.$t('common.AnnouncementNotNull'),
          stayTime: 5
        })
      } else {
        this.show = true
      }
    },
    cancel (val) {
      this.show = val
    },
    confirm (val) {
      let data = {
        taName: this.postData.brandCode,
        regionCode: this.postData.cityCode,
        notice: this.text
      }
      if (data.regionCode === '') {
        data.regionCode = 'ALL'
      }
      if (data.taName === '') {
        data.taName = 'ALL'
      }
      this.$axiox.post('/api/v1/admin/notice', data).then(res => {
        this.show = val
        this.getnoticeList()
        this.postData.brandCode = ''
        this.postData.cityCode = ''
        this.text = ''
        this.$commonJs.alertTips({
          type: 'success',
          content: this.$t('common.SubmitSuccess'),
          stayTime: 5
        })
      })
    },
    getoperation (item) {
      this.falg = true
      this.item = item
    },
    stop (val) {
      this.falg = val
    },
    cease () {
      this.$axiox.delete('/api/v1/admin/notice', { data: [this.item.Id] }).then(res => {
        this.falg = false
        this.getnoticeList()
        this.$commonJs.alertTips({
          type: 'success',
          content: this.$t('common.StopSuccessfully'),
          stayTime: 5
        })
      })
    },
    getChecked () {
      const arr = []
      this.check.forEach(el => {
        if (el.checked) {
          arr.push(el.name)
        }
      })
      return arr
    },
    // 全选
    selectAll (e) {
      const selectList = Array.from(this.$refs['checked'])
      selectList.forEach(el => {
        el.checked = e.target.checked
      })
    },
    checkedChange () {
      let num = 0
      const selectList = Array.from(this.$refs['checked'])
      selectList.forEach(el => {
        if (el.checked) {
          num++
        }
      })
      this.$refs.checkedAll.checked = (num === selectList.length)
    }
  }
}
</script>

<style>
#notice th {
  text-align: center;
  color: #8b8686;
  padding: 40px;
  font-size: 14px;
  font-weight: 400;
}
#notice input[type="checkbox"] {
  margin: 0 6px;
  -webkit-appearance: none;
  border: 1px solid #c50f3c;
  vertical-align: middle;
  width: 15px;
  height: 15px;
  border-radius: 4px;
}
#notice input[type="checkbox"]:checked {
  background-image: url("../../../assets/img/checked.png");
  background-size: 100%;
  background-color: #c50f3c;
}
#notice .multipleSelect .multipleSelectDrop {
  position: absolute;
  top: 32px;
  background: #fff;
  width: 100%;
  display: none;
  opacity: 0;
  -webkit-transition: opacity 0.2s;
  transition: opacity 0.2s;
  max-height: 200px;
  overflow: auto;
  -webkit-box-shadow: 0px 0px 5px 0px #ccc;
  box-shadow: 0px 0px 5px 0px #ccc;
  border-radius: 4px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.noticeTop {
  display: flex;
  padding-top: 20px;
}
.announcement {
  width: 3px;
  height: 15px;
  background: #c50f3c;
}
.cement {
  color: #c50f3c;
  font-weight: bold;
  padding-left: 8px;
}
.product_line {
  display: inline-block;
  color: #656565;
  padding: 50px 0px;
}
.select {
  padding-left: 50px;
  border-bottom: 1px solid #f1eaea;
}
.textarea {
  display: flex;
  width: 90%;
  height: 200px;
  border-radius: 5px;
  border: 1px solid #db6a85;
  margin-bottom: 15px;
}
/* textarea::placeholder {
  padding-left: 10px;
} */
textarea {
  width: 100%;
  padding: 10px;
  /* border: 1px solid #db6a85; */
  height: 180px;
  border-radius: 5px;
  resize: none;
  margin-bottom: 15px;
}

.submit {
  /*width: 100px;*/
  padding: 0 15px;
  height: 30px;
  background-color: #c50f3c;
  margin-top: 170px;
  line-height: 30px;
  text-align: center;
  vertical-align: middle;
  margin-left: 20px;
  color: white;
  cursor: pointer;
  border-radius: 30px;
  font-size: 14px;
  position: absolute;
  right: 2%;
}

.submit i {
  padding-right: 10px;
  vertical-align: middle;
  color: white;
}

#notice .dis_line {
  padding-right: 30px;
}
#notice .mainFixed {
  padding: 0 30px;
  margin: 10px 0;
}
.unload {
  position: absolute;
  right: 2%;
  /*width: 100px;*/
  padding: 0 15px;
  height: 30px;
  background-color: #c50f3c;
  line-height: 30px;
  text-align: center;
  vertical-align: middle;
  color: white;
  cursor: pointer;
  border-radius: 30px;
  font-size: 14px;
  margin-top: 15px;
  margin-bottom: 20px;
}
.unload i {
  padding-right: 10px;
  vertical-align: middle;
  color: white;
}
#notice .allTable thead td {
  border-bottom: 2px solid #d68497;
  padding: 12px 0px 10px 10px;
}
#notice .allTable tbody td {
  padding: 12px 0px 10px 10px;
}
#notice .allTable {
  width: 100%;
  margin-top: 64px;
}

#notice .allTable tbody tr:nth-of-type(odd) {
  background-color: #f9f9f9;
}
.affirm {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/notice/notice.vue